import React from 'react'
import Layout from '../components/layout'
import Meta from '../components/meta'
import tw, { css, styled } from 'twin.macro'
import { Check } from 'react-feather'
import { Link, navigate } from 'gatsby'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import {  graphql } from 'gatsby'
import Ecoclear_Logo_1 from '../images/Ecoclear_Logo_1.svg'


const EcoClear = props => {

	const {bannerImage, cartridgeCardImage, mediaCardImage, poolPumpCardImage, heatPumpCardImage, shopNowImage, cartridgeImage, mediaImage, poolPumpImage, heatPumpImage} = props.data
	const sectionList = [
		{
			title: <>Ecoclear<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>®</span><br tw='sm:hidden'/> Cartridge Filters</>,
			description: <>The Maytronics Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> Cartridge Filters deliver superior water clarity with <span tw='whitespace-nowrap'>ultra-fine</span> filtration while being water and energy efficient. Their compact <span tw='whitespace-nowrap'>space-saving</span> design makes them perfect for pools with limited equipment space. The standard Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> Cartridge Filters captures particles as small as 8 microns, while the <span tw='whitespace-nowrap'>Multi-Element</span> filter for larger pools, features antimicrobial silver ion technology to prevent bacteria. Durable, <span tw='whitespace-nowrap'>easy-to-clean</span> and ergonomically designed, these filters provide efficient, <span tw='whitespace-nowrap'>hassle-free</span> performance.</>,
			image: cartridgeImage.nodes[0],
			link: '/shop?brand=Ecoclear',
			background: '#353F47',
			titleColor: '#58C8DF',
			textColor: 'white',
			pwidth: '160%',
			imageMargin: 0,
			imageHeight: '100%',
			heightOffset: '0',
			id: 'cartridge-section'
		},
		{
			title: <>Ecoclear<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>®</span><br tw='sm:hidden'/> Media Filters</>,
			description: <>Maytronics Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> Media Filters deliver reliable, <span tw='whitespace-nowrap'>crystal-clear</span> pool water with minimal effort. Built with a durable <span tw='whitespace-nowrap'>weather-resistant</span> tank, they feature a <span tw='whitespace-nowrap'>6-function</span> <span tw='whitespace-nowrap'>multi-port</span> valve, <span tw='whitespace-nowrap'>360°</span> rotating clamp for easy installation, and a large filtration bed for efficient cleaning. Maintenance is simple with fast backwashing, and each filter comes with a <span tw='whitespace-nowrap'>10-year</span> tank warranty, ensuring <span tw='whitespace-nowrap'>long-lasting</span> performance. Designed to work with premium Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> Glass Media, these filters provide superior filtration for any pool system</>,
			image: mediaImage.nodes[0],
			link: '/shop?brand=Ecoclear',
			background: '#58C8DF',
			titleColor: 'black',
			textColor: 'black',
			pwidth: '160%',
			imageMargin: 0,
			imageHeight: '100%',
			heightOffset: '0',
			id: 'media-section'
		},
		{
			title: <>Ecoclear<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>®</span><br tw='sm:hidden'/> Pool Pumps</>,
			description: <>Maytronics Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> Pool Pumps offer energy efficiency and reliable performance in both variable and <span tw='whitespace-nowrap'>single-speed</span> models. The variable speed pumps adapt power to pool needs, cutting energy costs, while <span tw='whitespace-nowrap'>single-speed</span> pumps deliver efficient, quiet operation. Built with durable components, large strainer baskets, and transparent lids for easy maintenance, Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> pumps provide smooth, quiet performance, ensuring pristine water quality with minimal effort.</>,
			image: poolPumpImage.nodes[0],
			link: '/shop?brand=Ecoclear',
			background: '#353F47',
			titleColor: '#58C8DF',
			textColor: 'white',
			pwidth: '130%',
			imageMargin: '50px',
			imageHeight: '110%',
			heightOffset: '-50px',
			marginBottom: '-70px',
			id: 'poolpump-section'
		},
		{
			title: <>Ecoclear<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>®</span><br tw='sm:hidden'/> Heat Pumps</>,
			description: <>The Maytronics Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> Inverter Heat Pump offers reliable, <span tw='whitespace-nowrap'>eco-friendly</span> pool heating with advanced inverter technology for energy efficiency. Built to last with a titanium heat exchanger and self diagnosis features, it ensures optimal performance in any climate. Enjoy adjustable heating and cooling, backed by a <span tw='whitespace-nowrap'>15-year</span> warranty, for <span tw='whitespace-nowrap'>year-round</span> comfort and peace of mind in your pool.</>,
			image: heatPumpImage.nodes[0],
			link: '/shop?brand=Ecoclear',
			background: '#58C8DF',
			titleColor: 'black',
			textColor: 'black',
			pwidth: '130%',
			imageMargin: '50px',
			imageHeight: '120%',
			heightOffset: '-110px',
			marginBottom: '-110px',
			id: 'heatpump-section'
		},
	]
	return (
		<div>
			<Layout>
				<Meta
					title="Eco Clear Pool Equipments"
					keywords={['eco-clear', 'pool', 'equipment']}
					description=""
				/>
				<div tw='w-screen relative sm:-mb-2' css={css`
					@media (min-width: 1025px) {
					}
					`}>
					<div
						tw="z-20 absolute inset-0 h-full w-full">
				<Img {...bannerImage.nodes[0]} tw="w-full h-full" loading="eager" />
				</div>

				<div tw='text-white relative z-30 h-full w-full max-w-screen-lg mx-auto pt-4 pb-10 px-4'>					
					<div tw='w-full flex flex-col items-center'>
						<div tw='mb-4'>
							<img src={Ecoclear_Logo_1} alt="Eco Clear Logo" tw='h-16 md:h-24 xl:h-28 -mr-4 md:-mr-6 xl:-ml-10' />
						</div>
						<p tw='text-xs sm:text-lg px-2 sm:px-6 text-center'>Explore the Maytronics Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> range of pool equipment, featuring efficient filtration systems,
						<span tw='whitespace-nowrap'>energy-saving</span> pumps, and reliable heating solutions for comfortable and <span tw='whitespace-nowrap'>crystal-clear</span> water <span tw='whitespace-nowrap'>year-round.</span>
								Designed for effortless maintenance and energy efficiency Ecoclear<span tw="text-xs" style={{ verticalAlign: 'top' }}>®</span> products ensure your pool remains
								a pristine oasis while minimising costs.</p>
					</div>
					<div tw='flex flex-col xl:flex-row justify-between items-center gap-x-4 mt-4 sm:mt-8 whitespace-nowrap'>
						<ul tw='grid sm:grid-cols-2 flex-grow gap-x-6 w-full px-4 md:px-20 xl:px-0 xl:w-auto mt-4 sm:mt-0'>
								<li tw='h-full w-full' css={css`
										img {
										object-fit: contain !important;
										}
										`}>
									<Img {...cartridgeCardImage.nodes[0]} tw="w-full" loading="eager" />
								<div tw='w-full flex justify-center text-sm'><Link to="#cartridge-section" tw='text-center hover:bg-blue-500 bg-white text-black hover:text-white uppercase hover:font-bold font-medium rounded-2xl py-2' css={css`
									width: 70%;
									`}>Cartridge Filters</Link></div>
								</li>
								<li tw='h-full w-full' css={css`
										img {
										object-fit: contain !important;
										}
										`}>
									<Img {...mediaCardImage.nodes[0]} tw="w-full" loading="eager" />
								<div tw='w-full flex justify-center text-sm'><Link to="#media-section" tw='text-center hover:bg-blue-500 bg-white text-black hover:text-white uppercase hover:font-bold font-medium rounded-2xl py-2' css={css`
									width: 70%;
									`}>Media Filters</Link></div>
								</li>
								<li tw='h-full w-full' css={css`
										img {
										object-fit: contain !important;
										}
										`}>
									<Img {...poolPumpCardImage.nodes[0]} tw="w-full" loading="eager" />
								<div tw='w-full flex justify-center text-sm'><Link to="#poolpump-section" tw='text-center hover:bg-blue-500 bg-white text-black hover:text-white uppercase hover:font-bold font-medium rounded-2xl py-2' css={css`
									width: 70%;
									`}>Pool Pumps</Link></div>
								</li>
								<li tw='h-full w-full' css={css`
										img {
										object-fit: contain !important;
										}
										`}>
									<Img {...heatPumpCardImage.nodes[0]} tw="w-full" loading="eager" />
								<div tw='w-full flex justify-center text-sm'><Link to="#heatpump-section" tw='text-center hover:bg-blue-500 bg-white text-black hover:text-white uppercase hover:font-bold font-medium rounded-2xl py-2' css={css`
									width: 70%;
									`}>Pool Heating</Link></div>
								</li>
						</ul>	
						<div tw='h-full order-first xl:order-last' css={css`
						width: 100%;
						@media (min-width: 767px) and (max-width: 1024px) {
						width: 70%;
						}
						@media (min-width: 1025px) {
							width: 46%;
						}
							`}>
							<div tw='h-full w-full' css={css`
										img {
										object-fit: contain !important;
										object-position: center !important;
										}
										`}>
											<Link to='/product/ecoclear-future-variable-speed-pool-pump-1400-w-2-0-hp/'>
									<Img {...shopNowImage.nodes[0]} tw="w-full" loading="eager" />
									</Link>
								</div>
						</div>

					</div>
				</div>
				</div>
				<div tw='w-full pt-8 xl:pt-20 sm:hidden xl:block xxl:hidden' css={css`
					background: #353F47;
					`} ></div>
				
				{
					sectionList.map((list, index) =>(
						<section id={list.id} key={index} tw='w-full pt-10 sm:pt-0 mb-1 overflow-hidden'css={css`
							background: ${list.background};
							`}>
								<h3 tw='text-4xl md:text-3xl mb-4 sm:mb-0 text-center sm:hidden'  css={css`
								color: ${list.titleColor};
    `}>{list.title}</h3>
				<div tw='w-full max-w-screen-lg mx-auto py-10 px-4 sm:px-10 xl:px-4 flex flex-col sm:flex-row justify-between items-center'>
				<div tw='flex flex-col' css={css`
				@media (min-width: 640px) {
					width:${list.pwidth}
				}
					`}>
							<h3 tw='text-2xl lg:text-4xl xl:text-4xl mb-4 text-center sm:text-left hidden sm:block'  css={css`
								color: ${list.titleColor};
    `}>{list.title}</h3>
							<p tw='text-center sm:text-left text-sm lg:text-base xl:text-lg'  css={css`
								color: ${list.textColor};
    `}>{list.description}</p>
									<div tw='mt-10 flex justify-center sm:justify-start'>
							<Link to={list.link} tw='hover:bg-blue-500 bg-white text-black hover:text-white uppercase hover:font-bold font-medium rounded-2xl px-6 py-2 sm:py-1 lg:py-2 sm:text-xs lg:text-inherit hover:border hover:border-white'>SHOP NOW</Link>
							</div>
				</div>
				<div tw='h-full w-full order-first sm:order-last -mt-10 -mb-6 sm:mb-0 sm:mt-0' css={css`
						`}>
						<div tw='flex justify-center items-center pb-10 sm:pb-0' css={css`
						img {
									object-fit: contain !important;
						}
									@media (min-width: 1025px) {
									img {
									object-position: 50% 50% !important;
									height: ${list.imageHeight} !important;
									width: ${list.imageHeight} !important;
									margin-top: ${list.heightOffset}	!important;						
									}
									height: ${list.imageHeight} !important;
									width: ${list.imageHeight} !important;
									margin-left: ${list.imageMargin} !important;	
									margin-bottom: ${list.marginBottom ?? "0"} !important;	
						}
						margin-top: ${list.marginBottom ? "-20px" : "0"} !important;
						margin-bottom: ${list.marginBottom ? "-20px" : "0"} !important;
									`}
									
									>
								<Img {...list.image} tw="w-full" loading="eager" />
							</div>
					</div>
				</div>
			</section>
					))
				}
			</Layout>
		</div>
	)
}

// export const ecoClearQuery = graphql``


export const EcoClearPoolEquipmentPageQuery = graphql`
query EcoClearPoolEquipmentPageQuery {
		bannerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "64d3YUcQNrQyYG1Xd4Cdnm" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1900, maxHeight: 1050, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		cartridgeCardImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4sGvg4SeDH2hrriwL6tOYj" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 600, maxHeight: 450, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		mediaCardImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6T1eOR6LqOdCsUfPWJxBBT" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 600, maxHeight: 450, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		poolPumpCardImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "1QSl3EpomshUfvHxdpO1dx" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 600, maxHeight: 450, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		heatPumpCardImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4cAkfzsSYtkIZiexeizz2v" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 600, maxHeight: 450, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		shopNowImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4xWo6QGsaqkIK7ugiXHIOm" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 800, maxHeight: 700, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		cartridgeImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4m0MN0k8eSD6hpQPQ0HHoX" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 800, maxHeight: 700, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		mediaImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5vftO9csSpIzBel6LpU79U" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 800, maxHeight: 700, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		poolPumpImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "1PrW12N4m9Aw7TyuMIFT1a" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 800, maxHeight: 700, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		heatPumpImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "54WuB0W91X7AikvWMPL1iN" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 800, maxHeight: 700, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}


}
`

export default EcoClear


EcoClear.propTypes = {
	data: PropTypes.shape({
		bannerImage: PropTypes.object,
		cartridgeCardImage: PropTypes.object,
		mediaCardImage: PropTypes.object,
		poolPumpCardImage: PropTypes.object,
		heatPumpCardImage: PropTypes.object,
		shopNowImage: PropTypes.object,
		cartridgeImage: PropTypes.object,
		mediaImage: PropTypes.object,
		poolPumpImage: PropTypes.object,
		heatPumpImage: PropTypes.object,
})
}
